module.exports = __webpack_public_path__ + "img/batiment-BTS.f509bfbf.jpg";